import React, { useMemo, useState } from "react";
import { withTranslation } from "react-i18next";
import Card from "components/Card";
import Text from "components/Text";
import Input from "components/Input";
import styles from "./../../NewEmploymentContract.module.scss";
import "./MultiStep.scss";
import ToggleSwitch from "components/ToggleSwitch";
import ReactDatePickerCommon from "components/ReactDatePickerCommon";
import SavedTemplateSelectionModal from "./SavedTemplateSelectionModal";
import CustomEditorForContract from "../CustomEditor";
import { useCommonPlaceholderAndEditorRefs } from "../customEditorUtils";

function StepOne({
  contractData,
  setBasicDetails,
  errors,
  contractFormDisplayData,
  setFormDetails,
  setisSavedTemplate,
  savedTemplate,
  handleSwitch,
  t,
  hideRadio,
  fetchTemplateData,
  selectedTemplateId,
}) {
  const designationType = localStorage.getItem("designation")
    ? +localStorage.getItem("designation")
    : 2;
  const onchangeTemplate = (event) => {
    setisSavedTemplate(event.currentTarget.value);
  };
  const inputChange = (event) => {
    const { name, value } = event.target;
    setBasicDetails((prev) => ({ ...prev, [name]: value }));
  };
  const [savedTemplateModal, setSavedTemplateModal] = useState(false);
  const {
    placeholderDropdownOpen,
    setPlaceholderDropdownOpen,
    editorContainerRefs,
    editorContentRefs,
  } = useCommonPlaceholderAndEditorRefs();

  const contractField = useMemo(
    () =>
      contractFormDisplayData.map((data, key) => {
        if (data.isMainSection && data.stepNumber == 1) {
          return (
            <Card
              radius="10px"
              marginBottom="10px"
              padding="30px"
              shadow="0 0 15px 0 rgba(0, 0, 0, 0.08)"
              className={"pb-1 " + styles["card-container"]}
              key={key}
            >
              <div className="d-flex justify-content-between">
                <Text size="16px" secondary weight="600" marginBottom="20px">
                  {data.overallOrder - 3}. {data.title}
                </Text>
                <ToggleSwitch
                  label={data.title}
                  onChange={(e) => {
                    handleSwitch(key, e.currentTarget.checked);
                  }}
                  value={data.isActive}
                />
              </div>
              <div style={{ display: data.isActive ? "block" : "none" }}>
                <CustomEditorForContract
                  data={data}
                  editorContentRefs={editorContentRefs}
                  editorContainerRefs={editorContainerRefs}
                  uniqueKey={data.id}
                  index={key}
                  contractData={contractData}
                  placeholderDropdownOpen={placeholderDropdownOpen}
                  setPlaceholderDropdownOpen={setPlaceholderDropdownOpen}
                  setFormDetails={setFormDetails}
                />
              </div>
            </Card>
          );
        }
        return null;
      }),
    [contractFormDisplayData, placeholderDropdownOpen]
  );
  return (
    <div className={styles["step-form-wrapper"]}>
      {!hideRadio && (
        <Card
          radius="10px"
          marginBottom="10px"
          padding="30px"
          shadow="0 0 15px 0 rgba(0, 0, 0, 0.08)"
          className={styles["card-container"]}
        >
          <Text size="16px" secondary weight="600" marginBottom="20px">
            {t("contracts.templateYouWantToUse")}
          </Text>
          <div className="d-md-flex">
            <div className="ch-radio mr-5">
              <label>
                <input
                  type="radio"
                  name="template"
                  value="false"
                  onChange={onchangeTemplate}
                  checked={savedTemplate == "false"}
                />
                <span> {t("contracts.defaultTemplate")} </span>
              </label>
            </div>
            <div className="ch-radio">
              <label>
                <input
                  type="radio"
                  name="template"
                  value="true"
                  onChange={onchangeTemplate}
                  checked={savedTemplate == "true"}
                />
                <span> {t("contracts.recentlySavedTemplate")}</span>
              </label>
            </div>
          </div>
          {savedTemplate == "true" && (
            <div className="c-field mt-3">
              <div className={" d-flex justify-content-between  "}>
                <label
                  className={styles["c-field-label"]}
                  style={{ fontSize: 13, fontWeight: 400 }}
                >
                  {t("contracts.selectATemplate")}
                  <span style={{ color: "#EE4F4F" }}>*</span>
                </label>
                <span
                  className="link-btn"
                  onClick={() => {
                    setSavedTemplateModal(true);
                  }}
                >
                  {t("staff.select")}
                </span>
              </div>
              <div className="c-form-control " style={{ position: "relative" }}>
                <span>
                  {selectedTemplateId
                    ? selectedTemplateId?.name
                    : t("contracts.noTemplateSelected")}
                </span>
              </div>
              {errors?.savedTemplate && !selectedTemplateId && (
                <span className="error-msg">{errors.savedTemplate}</span>
              )}
              {savedTemplateModal && (
                <SavedTemplateSelectionModal
                  isOpen={savedTemplateModal}
                  closeStepOneModal={setSavedTemplateModal}
                  fetchAndSetTemplateData={async (id) => {
                    try {
                      const changed = await fetchTemplateData(id);
                      if (changed) {
                        setSavedTemplateModal(false);
                      }
                    } catch {}
                  }}
                  designationType={designationType}
                  selectedTemplateId={selectedTemplateId}
                />
              )}
            </div>
          )}
        </Card>
      )}
      <Card
        radius="10px"
        marginBottom="10px"
        padding="30px"
        shadow="0 0 15px 0 rgba(0, 0, 0, 0.08)"
        className={"pb-1 " + styles["card-container"]}
      >
        <Text size="16px" secondary weight="600" marginBottom="20px">
          {t("contracts.basicInfo")}
        </Text>
        <div className="c-field">
          <label>{t("contracts.dateContract")}</label>
          <div className="d-flex inputdate">
            <ReactDatePickerCommon
              selected={contractData.Date}
              onChange={(e) => {
                setBasicDetails({ ...contractData, Date: e });
              }}
              dateFormat="dd-MM-yyyy"
              className="c-form-control"
            />
            {errors.Date && <span className="error-msg">{errors.Date}</span>}
          </div>
        </div>
        <Input
          Title={t("contracts.businessLegalName")}
          Type="text"
          Placeholder={t("form.placeholder1", {
            field: t("contracts.businessLegalName"),
          })}
          Name={"BusinessLegalName"}
          HandleChange={inputChange}
          Value={contractData.BusinessLegalName}
          Error={errors.BusinessLegalName ? errors.BusinessLegalName : ""}
          MaxLength={80}
        />
        <Input
          Title={t("contracts.position")}
          Type="text"
          Placeholder={t("form.placeholder1", {
            field: t("contracts.position"),
          })}
          Name={"Position"}
          HandleChange={inputChange}
          Value={contractData.Position}
          Error={errors.Position ? errors.Position : ""}
          MaxLength={100}
        />
        <Input
          Title={t("form.fields.officeAddress")}
          Type="text"
          Placeholder={t("form.placeholder1", {
            field: t("form.fields.officeAddress"),
          })}
          Name={"OfficeAddress"}
          HandleChange={inputChange}
          Value={contractData.OfficeAddress}
          Error={errors.OfficeAddress ? errors.OfficeAddress : ""}
          MaxLength={200}
        />
        <Input
          Title={t("contracts.lengthEmployment")}
          Type="text"
          Placeholder={t("form.placeholder1", {
            field: t("contracts.lengthEmployment"),
          })}
          Name={"LengthOfEmployment"}
          HandleChange={inputChange}
          Value={contractData.LengthOfEmployment}
          Error={errors.LengthOfEmployment ? errors.LengthOfEmployment : ""}
          MaxLength={36}
        />
        <div className="c-field">
          <label>{t("contracts.startWork")}</label>
          <div className="d-flex inputdate">
            <ReactDatePickerCommon
              selected={contractData.StartOfWorkDate}
              onChange={(e) => {
                setBasicDetails({ ...contractData, StartOfWorkDate: e });
              }}
              dateFormat="dd-MM-yyyy"
              className="c-form-control"
            />
            {errors.StartOfWorkDate && (
              <span className="error-msg">{errors.StartOfWorkDate}</span>
            )}
          </div>
        </div>
        <div className="c-field">
          <label>{t("contracts.endWork")}</label>
          <div className="d-flex inputdate">
            <ReactDatePickerCommon
              selected={contractData.EndOfWorkDate}
              onChange={(e) => {
                setBasicDetails({ ...contractData, EndOfWorkDate: e });
              }}
              dateFormat="dd-MM-yyyy"
              className="c-form-control"
            />
            {errors.EndOfWorkDate && (
              <span className="error-msg">{errors.EndOfWorkDate}</span>
            )}
          </div>
        </div>

        <Input
          Title={t("contracts.employeeName")}
          Type="text"
          Placeholder={t("form.placeholder1", {
            field: t("contracts.employeeName"),
          })}
          Name={"EmployeeName"}
          HandleChange={inputChange}
          Value={contractData.EmployeeName}
          Error={errors.EmployeeName ? errors.EmployeeName : ""}
        />
        <Input
          Title={t("contracts.employeeAddress")}
          Type="text"
          Placeholder={t("form.placeholder1", {
            field: t("contracts.employeeAddress"),
          })}
          Name={"EmployeeAddress"}
          HandleChange={inputChange}
          Value={contractData.EmployeeAddress}
          Error={errors.EmployeeAddress ? errors.EmployeeAddress : ""}
          MaxLength={200}
        />
        <Input
          Title={t("contracts.salaryFeeWage")}
          Type="text"
          Placeholder={t("form.placeholder1", {
            field: t("contracts.salaryFeeWage"),
          })}
          Name={"Salary"}
          HandleChange={inputChange}
          Value={contractData.Salary}
          Error={errors.Salary ? errors.Salary : ""}
          MaxLength={100}
        />
        <Input
          Title={t("contracts.Commission")}
          Type="text"
          Placeholder={t("form.placeholder1", {
            field: "",
          })}
          Name={"commission"}
          Value={contractData?.commission}
          Error={errors.commission ? errors.commission : ""}
          HandleChange={inputChange}
          MaxLength={300}
        />
        <Input
          Title={t("contracts.Bonus")}
          Type="text"
          Placeholder={t("form.placeholder1", {
            field: "",
          })}
          Name={"bonus"}
          Value={contractData?.bonus}
          HandleChange={inputChange}
          Error={errors.bonus ? errors.bonus : ""}
          MaxLength={300}
        />
      </Card>
      <Card
        radius="10px"
        marginBottom="10px"
        padding="30px"
        shadow="0 0 15px 0 rgba(0, 0, 0, 0.08)"
        className={"pb-1 " + styles["card-container"]}
      >
        {contractFormDisplayData.map(
          (data, key) =>
            !data.isMainSection &&
            data.stepNumber == 1 && (
              <Input
                key={key}
                Title={data.title}
                Type="text"
                Placeholder={t("form.placeholder1", {
                  field: t("contracts.salutation"),
                })}
                Name={data.title}
                Value={data.text}
                HandleChange={(e) => setFormDetails(key, e.currentTarget.value)}
                Error={data.error ? data.error : ""}
              />
            )
        )}
      </Card>
      {designationType === 2 && (
        <div className="new_contract_step1_associate_CF">
          <div className="Rectangle"></div>
          <span className="Job-Title">
            {t("contracts.ownerAndTheAssociateAgree")}
          </span>
        </div>
      )}
      {contractField}
    </div>
  );
}
export default withTranslation()(StepOne);
